/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { ScrollArea, sizes } from '@smartsheet/lodestar-core';
import { debounce } from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PanelHeader } from '../../../../common/Panel/Panel';
import { AddModuleList } from '../AddModuleList/AddModuleList';
import { SearchBar } from './SearchBar';

interface AddModulePanelProps {
  closePanel: any;
}

export const AddModulePanel = ({ closePanel }: AddModulePanelProps) => {
  const { t: translate } = useTranslation();

  const [searchTerm, setSearchTerm] = useState('');

  const updateSearchTerm = debounce(
    value => {
      setSearchTerm(value);
    },
    300,
    { trailing: true }
  );

  return (
    <React.Fragment>
      <PanelHeader
        title={translate('designer:rightRail.addModule')}
        onClose={closePanel}
      />
      <SearchBar onChange={updateSearchTerm} />
      <ScrollArea
        gutter="none"
        scrollbarStyle="slim"
        css={css`
          margin-top: ${sizes.medium}px;
          margin-bottom: ${sizes.medium}px;
        `}
      >
        <AddModuleList searchTerm={searchTerm} />
      </ScrollArea>
    </React.Fragment>
  );
};
